<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-6"
        :placeholder="$t('name')"
        :label="$t('name')"
        help="Este es el nombre del Widget con el que se mostrará en los listados"
        :v="$v.value.name"
        v-model="value.name"
      />
      <LmTextInput
        class="col-6"
        :placeholder="$t('title')"
        :label="$t('title')"
        help="Este es el título del gráfico"
        :v="$v.value.title"
        v-model="value.title"
      />
    </b-row>
    <b-row>
      <LmTreeSelect
        class="col-6"
        label="Origen de datos"
        pathToGetOptions="/datatables/all"
        :v="$v.value.dataOrigin"
        v-model="value.dataOrigin"
        @input="onDataOriginChange"
      />
      <LmSelect
        :key="aggTermKey"
        class="col-6"
        label="Propiedades"
        :options="aggOptions"
        v-model="value.aggTerm"
        :v="$v.value.aggTerm"
        :disabled="!value.dataOrigin"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_in')"
        type="multiple"
        :options="availableInOptions"
        v-model="value.availableIn"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmSelect from '@/components/form/elements/LmSelect'

export default {
  mixins: [lmToasts],
  components: {
    LmTextInput,
    LmCheckbox,
    LmTreeSelect,
    LmSelect
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      availableInOptions: [
        {
          text: 'Bandeja de Entradas',
          value: 'inbox'
        },
        {
          text: 'Dashboard',
          value: 'dashboard'
        }
      ],
      aggTermKey: 0,
      aggOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      },
      source: null,
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ]
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      title: {
        required
      },
      dataOrigin: {
        required
      },
      aggTerm: {
        required
      }
    }
  },
  methods: {
    async loadAggToRenderOptions (event) {
      const res = await commonsApi.axiosGetWrapper(`/datatables/${event}`)
      this.source = res.data.widget

      if (this.source.fields.length) {
        this.aggOptions.content = this.source.fields.map(el => {
          return {
            text: el.label,
            value: el.value
          }
        })
      }
    },
    async onDataOriginChange (event) {
      try {
        if (!event) {
          this.aggOptions = []
          this.value.aggTerm = null
          return
        }
        this.value.aggTerm = null
        await this.loadAggToRenderOptions(event.id)
        this.aggTermKey++
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    if (this.value.dataOrigin) {
      await this.loadAggToRenderOptions(this.value.dataOrigin.id)
    }
    if (this.isOnEditMode) {
      if (this.value.dataOrigin) {
        await this.loadAggToRenderOptions(this.value.dataOrigin.id)
      }
    }
  }
}
</script>
